import SwipeableViews from 'react-swipeable-views-react-18-fix';
import React from 'react';

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

/**
 * Renders a view component used to house content corresponding to each mobile tab (e.g diagram, ranking table).
 *
 * @component
 * @param {Object} props The components props
 * @param {React.ReactNode} props.children React children components to be rendered within the view
 * @param {Number} props.value The currently selected tab
 * @param {Number} props.index The tab's index
 * @returns {React.ReactElement}
 */
function MobileTabView(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            {...other}
        >
            {value === index && (
                <Box
                    sx={{ paddingTop: 1, overflow: 'hidden', paddingBottom: 8 }}
                >
                    {children}
                </Box>
            )}
        </Box>
    );
}

MobileTabView.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

// eslint-disable-next-line react/prop-types
const MobileSwipeableView = ({ mobileTab, setMobileTab, children }) => {
    const theme = useTheme();
    return (
        <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={mobileTab}
            onChangeIndex={(index) => setMobileTab(index)}
        >
            {children.map((child, index) => {
                return (
                    <MobileTabView
                        key={index}
                        value={mobileTab}
                        index={index}
                        dir={theme.direction}
                    >
                        {child}
                    </MobileTabView>
                );
            })}
        </SwipeableViews>
    );
};

MobileSwipeableView.propTypes = {
    mobileTab: PropTypes.number.isRequired,
    setMobileTab: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ])
};

export default MobileSwipeableView;
